module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/6-4b9e964d13cf3c6e39a5e01b4790f3d4.svg";